import { useTranslation } from "react-i18next";
import "./changepasswor.scss";
import MainLayout from "../../layouts/layout";
import { Breadcrumb, Button, Col, Form, Input, Row, message } from "antd";
import { _adr } from "../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { convertPersian } from "../../../tools/tools";
import { useAPIPublic } from "../../../tools/api";
import Loading from "../../auxiliary/loader/loading";
import { useState } from "react";

const Changepassword = () => {
  const [t] = useTranslation("global");

  const [messageApi, contextHolder] = message.useMessage();

  const { updateUserPassword } = useAPIPublic();

  const [frmChangePassword] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      let valid = await frmChangePassword.validateFields();
      if (valid) {
        let payload = {
          oldepassword: valid?.oldpassword,
          newpassword: valid?.newpassword,
        };
        let response = await updateUserPassword(payload);
        if (response) {
          messageApi.open({
            type: "success",
            content: "رمز عبور جدید با موفقیت تغییر کرد.",
          });
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };
  return (
    <>
      {contextHolder}
      <div className="container-main container-cs">
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("acounts.changepassword.title") }]}
          />
          <div className="title-page">
            <h3>{t("acounts.changepassword.title")}</h3>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main cs-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="holder-changepassword">
                  <Row>
                    <Col span={8}>
                      <Form form={frmChangePassword} layout="vertical">
                        <Form.Item
                          className="input-normal"
                          name="oldpassword"
                          label="رمز عبور فعلی"
                          rules={[
                            {
                              required: true,
                              message: t("validation.required"),
                            },
                          ]}
                        >
                          <Input.Password dir="ltr" placeholder="رمز عبور فعلی را وارد کنید" />
                        </Form.Item>
                        <Form.Item
                          className="input-normal"
                          name="newpassword"
                          label="رمز عبور جدید"
                          rules={[
                            {
                              required: true,
                              message: t("validation.required"),
                            },
                            {
                              validator: (_, value) => {
                                if (value && value.length < 8) {
                                  return Promise.reject(t("validation.minPassword"));
                                }
                                if (!/[a-zA-Z]/.test(value) || !/[0-9]/.test(value)) {
                                  return Promise.reject(t("validation.complexPassword"));
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input.Password dir="ltr" placeholder="رمز عبور جدید را وارد کنید" />
                        </Form.Item>
                        <Form.Item
                          className="input-normal"
                          name="newpasswordconfirm"
                          rules={[
                            {
                              required: true,
                              message: t("validation.required"),
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (!value || getFieldValue("newpassword") === value) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error(t("validation.equalTo")));
                              },
                            }),
                          ]}
                          label="تکرار رمز عبور جدید"
                        >
                          <div>
                            <Input.Password
                              dir="ltr"
                              placeholder="رمز عبور جدید را تکرار کنید"
                              autoComplete="off"
                              onChange={(e) => {
                                e.target.value = convertPersian(e.target.value);
                              }}
                            />
                          </div>
                        </Form.Item>
                      </Form>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="g-footer-format-page">
                <div className="holder-button">
                  <Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit}>
                    ثبت
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </div>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default Changepassword;
